const modalDialogWrapper = document.querySelector('#contact-modal-wrapper');
const contactModalCloseButton = document.querySelector('#contact-modal-close-button');

const contactModalWrapper = {

	registerEvents: () => {
		contactModalCloseButton.addEventListener('click', contactModalWrapper.handleClose());
		document.addEventListener('keydown', function (event) {
			if (event.key === "Escape") {
				if (modalDialogWrapper.style.display == 'block') {
					contactModalWrapper.handleClose();
				}
			}
		});
	},

	handleOpen: () => {
		//console.log('open modal');

		if (modalDialogWrapper.style.display == 'none') {
			modalDialogWrapper.style.display = 'block';
			modalDialogWrapper.classList.add('open');
			modalDialogWrapper.setAttribute('aria-hidden', 'false');
			modalDialogWrapper.setAttribute('aria-expanded', 'true');
			modalDialogWrapper.querySelector('textarea').focus();
		}

	},

	handleClose: () => {
		//console.log('closeModal');

		if (modalDialogWrapper.style.display == 'block') {
			modalDialogWrapper.style.display = 'none';
			modalDialogWrapper.classList.remove('open');
			modalDialogWrapper.setAttribute('aria-hidden', 'true');
			modalDialogWrapper.setAttribute('aria-expanded', 'false');
		}
	},

	init: () => {

		contactModalWrapper.registerEvents();

		if (!modalDialogWrapper) return;

		if (typeof modalDialogWrapper != 'undefined' && modalDialogWrapper != null) {
			contactModalCloseButton.onclick = function (e) {
				contactModalWrapper.handleClose();
			};
			modalDialogWrapper.onclick = function (e) {
				e.stopPropagation();
			};
		}

	},

};

export default contactModalWrapper;